import React from 'react';

import { MixedVideoPanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const MixedVideoPanelPage = props => (
  <MixedVideoPanel {...props} notificationApi={notificationApi} />
);
